import React, { useState, useEffect } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../HandleHttpErrors";
const baseURL = process.env.REACT_APP_API;
const MekhrazeemRep = () => {
  // State for the selected year
  const [selectedYear, setSelectedYear] = useState(null);
  const [years, setYears] = useState(null);
  const [mekhrazRep, setMekhrazRep] = useState(null);
  const [mekhrazDepartmentRep, setMekhrazDepartmentRep] = useState(null);
  const [uniqueMkhTypes, setUniqueMkhTypes] = useState(null);

  // Function to handle year selection
  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
    // You can fetch data based on the selected year here
  };
  const axiosPrivate = useAxiosPrivate("application/json");

  useEffect(() => {
    document.body.classList.add("accountBodyColor");
    let isMounted = true;
    const controller = new AbortController();
    const getYears = async () => {
      try {
        const response = await axiosPrivate
          .get(baseURL + "jobs/years/", {
            signal: controller.signal,
          })
          .then((response) => {
            setYears([
              "ללא הגבלה",
              ...response.data.years.map((member) => String(member)),
            ]);
          });
      } catch (err) {
        console.error(err);
      }
    };
    getYears();
    return () => {
      document.body.classList.remove("accountBodyColor");
      isMounted = false;
      isMounted && controller.abort();
    };
  }, []);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getMekhrazRep = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "jobs/mekhrazrep/?year=" + selectedYear,
          {
            signal: controller.signal,
          },
        );

        if (isMounted) {
          setMekhrazRep(response.data[0]);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    const getMekhrazDepartmentRep = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "jobs/mekhrazdepartmentrep/?year=" + selectedYear,
          {
            signal: controller.signal,
          },
        );

        if (isMounted) {
          setMekhrazDepartmentRep(response.data);

          setUniqueMkhTypes([
            ...new Set(response.data.map((item) => item.mkh_type_display)),
          ]);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };

    getMekhrazRep();
    getMekhrazDepartmentRep();

    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, [selectedYear]);
  const dataMap = mekhrazDepartmentRep?.reduce((map, item) => {
    const key = `${item.department__title}_${item.mkh_type_display}`;
    map[key] = (map[key] || 0) + item.count;
    return map;
  }, {});

  // Create the table rows
  const tableRows =
    !mekhrazRep || !mekhrazDepartmentRep
      ? []
      : [
          ...new Set(
            mekhrazDepartmentRep?.map((item) => item.department__title),
          ),
        ].map((department) => {
          // Calculate the sum of the first three columns
          const sum = uniqueMkhTypes.slice(0, 3).reduce((acc, mkhType) => {
            return acc + (dataMap[`${department}_${mkhType}`] || 0);
          }, 0);
          const pct = mekhrazRep
            ? Math.round((sum / mekhrazRep.mkall) * 100)
            : 0;
          return (
            <tr key={department} style={{ borderBottom: "1px solid #ddd" }}>
              <td style={{ textAlign: "center" }}>{department}</td>
              {uniqueMkhTypes?.map((mkhType, index) => (
                <td style={{ textAlign: "center" }} key={mkhType}>
                  {dataMap[`${department}_${mkhType}`] || 0}
                </td>
              ))}
              {/* Add a new column for the sum of columns 1, 2, and 3 */}
              <td style={{ textAlign: "center", fontWeight: "bold" }}>{sum}</td>
              <td style={{ padding: "6px 10px", minWidth: "120px" }}>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "6px" }}
                >
                  <div
                    style={{
                      flex: 1,
                      minWidth: 0,
                      height: "12px",
                      background: "#bbb",
                      borderRadius: "5px",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        width: `${pct}%`,
                        height: "100%",
                        background: "#3399ff",
                        borderRadius: "5px",
                        minWidth: pct > 0 ? "4px" : "0",
                      }}
                    />
                  </div>
                  <span
                    style={{
                      fontSize: "12px",
                      color: "#555",
                      minWidth: "28px",
                    }}
                  >
                    {pct}%
                  </span>
                </div>
              </td>
            </tr>
          );
        });

  return (
    <div>
      {/* First line: Dropdown to select a year */}
      <h2 style={{ textAlign: "center", color: "white" }}>
        {selectedYear && selectedYear.trim() !== "ללא הגבלה"
          ? `סטטיסטיקה של המכרזים לשנת ${selectedYear}`
          : "סטטיסטיקה של המכרזים ללא הגבלת שנה"}
      </h2>
      <div>
        <label
          style={{ color: "black", fontWeight: "bold", marginLeft: "10px" }}
        >
          בחר שנה להצגה:
        </label>

        <select onChange={handleYearChange} value={selectedYear}>
          {years?.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
        <br />
        <br />
      </div>

      {/* Second part: Two blocks with statistics */}
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div
          style={{
            marginLeft: "20px",
            flex: 1,
            backgroundColor: "rgb(200, 200, 200)",
          }}
        >
          <h2>
            {selectedYear && selectedYear !== "ללא הגבלה"
              ? `סטטיסטיקה של המכרזים לשנת ${selectedYear}`
              : "סטטיסטיקה של המכרזים ללא הגבלת שנה"}
          </h2>
          <div
            style={{ color: "black", fontWeight: "bold" }}
            className="rightmargin"
          >
            <p>המספר הכולל: {mekhrazRep?.mkall}</p>
            <p>מתוכם בוטלו: {mekhrazRep?.mk_canceled}</p>
            {/* Add more statistics as needed */}
          </div>
        </div>

        {/* Block 2 */}
        <div
          style={{
            marginRight: "20px",
            flex: 1,
            backgroundColor: "rgb(200, 200, 200)",
          }}
        >
          <h2>מספר המכרזים לפי סוג המכרז</h2>
          <div
            style={{ color: "black", fontWeight: "bold" }}
            className="rightmargin"
          >
            <p>
              פומביים: {mekhrazRep?.mkpombi}, מתוכם בוטלו{" "}
              {mekhrazRep?.mkpombi_canceled}{" "}
            </p>
            <p>
              פנימיים: {mekhrazRep?.mkpnimi}, מתוכם בוטלו{" "}
              {mekhrazRep?.mkpnimi_canceled}
            </p>
            <p>
              פטור: {mekhrazRep?.mkptor}, מתוכם בוטלו{" "}
              {mekhrazRep?.mkptor_canceled}
            </p>
            {/* Add more statistics as needed */}
          </div>
        </div>
      </div>
      {/* Another block below the two existing blocks */}
      <div style={{ marginTop: "20px", backgroundColor: "rgb(200, 200, 200)" }}>
        <center>
          {" "}
          <h2>התפלגות המכרזים לפי המחלקות</h2>
        </center>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "black",
            fontWeight: "bold",
          }}
        >
          <table>
            <thead>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <th className="padding10-td ">מחלקה</th>
                {uniqueMkhTypes?.map((mkhType) => (
                  <th className="padding10-td " key={mkhType}>
                    {mkhType}
                  </th>
                ))}
                <th>סה"כ</th>
              </tr>
            </thead>
            <tbody>
              {!mekhrazRep ? (
                <tr>
                  <td colSpan={100}>טוען...</td>
                </tr>
              ) : (
                tableRows
              )}
            </tbody>
          </table>
        </div>
        <div>
          <br />
        </div>
      </div>
    </div>
  );
};

export default MekhrazeemRep;
